// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3-hLh","left":"styles_left__hSoxd","desktopActions":"styles_desktopActions__2Km18","title":"styles_title__2PNwz"};